import { NgModule, ModuleWithProviders } from "@angular/core";

import { BidiModule } from "@angular/cdk/bidi";
import { LayoutModule } from "@angular/cdk/layout";
import { CdkTableModule } from "@angular/cdk/table";

import { MatLegacyAutocompleteModule as MatAutocompleteModule } from "@angular/material/legacy-autocomplete";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyListModule as MatListModule } from "@angular/material/legacy-list";
import {
  MatLegacyFormFieldModule as MatFormFieldModule,
  MAT_LEGACY_FORM_FIELD_DEFAULT_OPTIONS as MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatLegacyFormFieldDefaultOptions as MatFormFieldDefaultOptions,
} from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacySlideToggleModule as MatSlideToggleModule } from "@angular/material/legacy-slide-toggle";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { MatLegacyTableModule as MatTableModule } from "@angular/material/legacy-table";
import { MatLegacySnackBarModule as MatSnackBarModule } from "@angular/material/legacy-snack-bar";
import {
  MatLegacyTooltipModule as MatTooltipModule,
  MAT_LEGACY_TOOLTIP_DEFAULT_OPTIONS as MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatLegacyTooltipDefaultOptions as MatTooltipDefaultOptions,
} from "@angular/material/legacy-tooltip";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatLegacyProgressBarModule as MatProgressBarModule } from "@angular/material/legacy-progress-bar";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatExpansionModule } from "@angular/material/expansion";

import {
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MatMomentDateModule,
} from "@angular/material-moment-adapter";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { ObserversModule } from "@angular/cdk/observers";
import { OverlayModule } from "@angular/cdk/overlay";

const EXPORTED_MODULES = [
  ObserversModule,
  OverlayModule,
  BidiModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatMenuModule,
  MatSidenavModule,
  MatToolbarModule,
  MatIconModule,
  MatListModule,
  MatSlideToggleModule,
  MatFormFieldModule,
  MatInputModule,
  MatRadioModule,
  MatTableModule,
  MatSnackBarModule,
  MatTooltipModule,
  MatDialogModule,
  MatSelectModule,
  MatCheckboxModule,
  MatButtonToggleModule,
  MatTabsModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatCardModule,
  MatExpansionModule,
  LayoutModule,
  CdkTableModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatMomentDateModule,
  MatBottomSheetModule,
];

const TooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 100,
  hideDelay: 100,
  touchendHideDelay: 10,
  position: "above",
};

// A field that names no appearance used to fall back to Material's `legacy`,
// which draws an underline instead of the box the shared field styles now paint.
// `fill` is what the templates ask for almost everywhere, so it becomes the
// default and the two look alike without touching a template.
const FormFieldDefaults: MatFormFieldDefaultOptions = {
  appearance: "fill",
};

const APP_DATE_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

const EXPORTED_SERVICES = [
  { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  { provide: MAT_DATE_LOCALE, useValue: "he-IL" },
  { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: TooltipDefaults },
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: FormFieldDefaults },
  { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
];

@NgModule({
  imports: EXPORTED_MODULES,
  exports: EXPORTED_MODULES,
  providers: EXPORTED_SERVICES,
})
export class MaterialModule {
  static forRoot(): ModuleWithProviders<MaterialModule> {
    return {
      ngModule: MaterialModule,
      providers: EXPORTED_SERVICES,
    };
  }
}
